// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"06265d2a","143":"c7870d3a","192":"bbca74df","295":"45b21953","349":"fc397536","351":"20c6b67e","592":"7a52e44e","655":"a60b56ce","813":"e255d1d1","866":"dec107d8","927":"e758cb0e","963":"08c790a4"}[chunkId] + ".chunk.js";
};